{
	"404": {
		"go-to-home-screen": "Przejdź do ekranu głównego",
		"this-screen-doesnt-exist": "Ten ekran nie istnieje"
	},
	"flag": "🇵🇱",
	"common": {
		"add": "Dodaj",
		"create": "Utwórz",
		"e-mail": "E-mail",
		"edit": "Edytuj",
		"no": "Nie",
		"or": "Lub",
		"password": "Hasło",
		"save": "Zapisz",
		"select": "Wybierz",
		"selected": "Wybrany",
		"select-all": "Wybierz wszystkich",
		"selected-all": "Wybrano wszystkich",
		"sign-out": "Wyloguj się",
		"yes": "Tak",
		"language": "Język",
		"saving": "Zapisywanie",
		"delete": "Usuń",
		"next": "Dalej",
		"get-started": "Zacznij",
		"skip": "Pomiń",
		"optional": "opcjonalne",
		"read-more": "Czytaj więcej",
		"show-less": "Pokaż mniej",
		"cancel": "Anuluj",
		"search": "Szukaj",
		"send": "Wyślij",
		"done": "Gotowe",
		"password-requirements-hint": "Min {{minLength}} znaków, jedna cyfra, jeden znak specjalny",
		"view-all": "Pokaż wszystkie",
		"back": "Wstecz",
		"steps-of-total": "{{completed}} z {{total}}",
		"more": "Więcej",
		"beta": "beta",
		"block": "Zablokuj",
		"ok": "OK"
	},
	"connections": {
		"connect": "Połącz",
		"connections": "Znajomości",
		"enter-the-information-about-user-to-bind-account-to-pletly-pal": "Wprowadź informacje o użytkowniku, aby powiązać konto z Pletly Pal",
		"enter-the-information-about-user-to-create-account-in-pletly-pal": "Wprowadź żądane informacje, aby utworzyć konto dla Wychowanka. \nZostaniesz przypisany jako właściciel utworzonego konta.",
		"oops-kinda-quiet-here": "Ups! \nTrochę cicho tutaj?",
		"to-be-able-to-use-pletly-pal-as-intended-and-see-resourcename-you-have-to-be-connected-to-one-or-more-users": "Aby móc używać Pletly Pal zgodnie z przeznaczeniem i widzieć {{resourceName}}, musisz być połączony z jednym lub kilkoma użytkownikami",
		"are-you-sure-you-want-to-remove-name-from-connections": "Jesteś pewien, że chcesz usunąć {{name}} z połączeń?",
		"remove-name": "Usuń {{name}}",
		"invites-of-your-proteges": "Zaproszenia Twoich Wychowanków",
		"tab-groups": "Grupy",
		"tab-users": "Użytkownicy",
		"users-count_one": "{{count}} użytkownik",
		"users-count_few": "{{count}} użytkowników",
		"users-count_many": "{{count}} użytkowników",
		"my-connections": "Moje kontakty",
		"create-group": "Utwórz grupę",
		"name-group": "Nazwij grupę",
		"edit-group-name": "Edytuj nazwę grupy",
		"are-you-sure-you-want-delete-group": "Czy na pewno chcesz usunąć grupę {{name}}?",
		"delete-group": "Usuń grupę",
		"are-you-sure-you-want-remove-from-group": "Czy na pewno chcesz usunąć {{name}} z grupy?",
		"remove-user": "Usuń użytkownika",
		"add-friends-to-view-post": "Pletly jest fajniejsza z innymi użytkownikami. Dowiedz się, czy ktoś z Twoich już dołączył lub zrobił kilka nowych.",
		"sent-invites": "Wysłane zaproszenia",
		"choose-how-you-want-to-connect-care-receiver": "Wybierz sposób połączenia z Wychowankiem. \nMożesz utworzyć nowe konto lub połączyć się z już istniejącym.",
		"connect-new-care-receiver": "Podłącz nowego Wychowanka",
		"connect-to-care-receiver": "Podłącz do Wychowanka",
		"create-care-receiver": "Utwórz Wychowanka",
		"create-care-receiver-account": "Utwórz konto Wychowanka",
		"who-sent-invite": "{{who}} wysłał zaproszenie",
		"connection-request-successfully-sent": "Zaproszenie zostało pomyślnie wysłane",
		"new-request": "Nowe zaproszenie",
		"new-invitation": "Nowe zaproszenie",
		"create-another-care-recipient": "Utwórz kolejnego Wychowanka",
		"invite-caregivers": "Zaproś Opiekunów",
		"created-account-successfully-for": "Pomyślnie utworzyłeś konto dla {{name}}",
		"you-can-invite-others-to-connect-to": "Możesz zaprosić inne osoby do połączenia się z {{name}} jako Opiekunowie lub utworzyć inne konto Wychowanka",
		"invite-others-to-connect-with": "Zaproś innych do połączenia z {{name}}",
		"enter-emails-of-caregivers-you-want-connect": "Wpisz adresy e-mail Opiekunów, z którymi chcesz połączyć {{name}}",
		"send-invitations": "Wyślij zaproszenia",
		"invitations-to-become-caregiver": "Zaproszenia, aby zostać Opiekunem",
		"invitations-to-connect": "Zaproszenia do połączenia",
		"cancel-invitation": "Anulować zaproszenie?",
		"bravo-you-managed-create-account": "Brawo! Udało Ci się utworzyć konto dla {{name}}",
		"add-connection": "Dodaj kontakt",
		"oops-look-like-you-dont-have-any-connections": "Ups! \nWygląda na to, że nie masz żadnych kontaktów.",
		"do-you-want-to-fill-information": "Czy chcesz teraz uzupełnić informacje o Wychowanku?",
		"add-information": "Uzupełnij informacje",
		"create-account-for-care-recipient": "Utwórz konto dla Wychowanka",
		"add-information-about-care-recipient": "Dodaj informacje o Wychowanku",
		"thank-you-additional-information-is-helpful": "Dziękujemy!\nDodatkowe informacje są zawsze pomocne!",
		"invite-family-members-to-be-connected-to": "Zaproś członków rodziny do połączenia z {{ name }}.",
		"enter-the-email-addresses-of-the-family-members-that-youd-like-to-have-connected-to": "Wpisz adresy e-mail członków rodziny, z którymi chcesz się połączyć {{ name }}",
		"organisation-requests": "Żądania organizacji",
		"request-accepted": "Prośba zaakceptowana",
		"care-receiver-is-now-part-of-the-organisation": "Odbiorca opieki jest teraz częścią organizacji",
		"request-rejected": "Żądanie odrzucone",
		"temporary-access": "Dostęp tymczasowy",
		"transfer-name-to-organisation": "Transfer {{name}} do {{organisation}}"
	},
	"post": {
		"add-a-comment": "Dodaj komentarz",
		"are-you-sure-you-want-to-delete-this-post": "Czy na pewno chcesz usunąć ten post?",
		"comments": "Komentarze",
		"delete-post": "Usuń post",
		"likes": "Polubienia",
		"new": {
			"add-text": "Dodaj tekst",
			"add-users": "Dodaj użytkowników",
			"create-new-post": "Utwórz nowy post",
			"edit-post": "Edytuj post",
			"permission-to-access-camera-roll-is-required": "Wymagane jest zezwolenie na dostęp do aparatu",
			"post-privacy": "Prywatność posta",
			"saving-post": "Zapisywanie posta",
			"and-others_one": "i {{count}} inny",
			"and-others_few": "i {{count}} innych",
			"and-others_many": "i {{count}} innych",
			"your-post-is-being-published": "Twój post jest publikowany...",
			"publish": "Opublikuj",
			"save-settings": "Zapisz ustawienia",
			"publication-settings": "Ustawienia publikacji",
			"your-care-recipients": "Twoi wychowankowie",
			"search-care-recipients": "Wyszukaj wychowanków",
			"errors": {
				"content-media-required": "Wymagana treść tekstowa lub multimedia",
				"privacy": "Wybierz co najmniej jednego odbiorcę opieki"
			},
			"info": {
				"post-submitted-for-review": "Twój post został przesłany do sprawdzenia",
				"post-edited-and-resubmited-for-review": "Post został zedytowany i przesłany ponownie do sprawdzenia"
			},
			"your-teams": "Twoje zespoły",
			"organisation": "Organizacja",
			"all-employees": "Wszyscy pracownicy",
			"select": "Wybierz",
			"team": "Zespół ({{ count }})",
			"blur-faces": {
				"previous-photo": "Poprzednie zdjęcie",
				"next-photo": "Następne zdjęcie",
				"blur-faces-in-photos": "Zamazuj twarze na zdjęciach ({{ count }})",
				"add-a-photo-of-the-care-recipients-face-that-is-not-to-be-blured-out": "Dodaj zdjęcie twarzy podopiecznego, które nie powinno być zamazane.",
				"care-receiver-reference-photo": "Zdjęcie referencyjne podopiecznego",
				"blur-all": "Zamaż wszystkie"
			},
			"schedule-for-later": "Zaplanuj na później",
			"to-be-published": "Do publikacji",
			"date": "Data",
			"time": "Czas",
			"show-scheduled-posts": "Zobacz wszystkie zaplanowane posty",
			"restrict-visibility-checkbox": "Ogranicz widoczność tylko do profesjonalnych opiekunów"
		},
		"post": "Post",
		"see-all-comments": "Zobacz wszystkie komentarze",
		"selected-users": "Wybrani użytkownicy",
		"users-publications": "publikacje użytkownika",
		"comment-actions": "Komentuj działania",
		"delete-comment-content": "Czy na pewno chcesz usunąć komentarz?",
		"delete-comment-title": "Usunąć komentarz?",
		"editing-comment": "Edytowanie komentarza",
		"pin-post": "Przypnij post",
		"unpin-post": "Odepnij post",
		"pinned-post": "Przypięty post",
		"welcome-post": {
			"get-to-know-care-receivers": "Poznaj Wychowanków",
			"pletly-pal-offers-custom-made-biography": "Pletly oferuje spersonalizowaną biografię wszystkich Twoich Wychowanków.",
			"swipe-left-to-learn-more": "Przesuń palcem w lewo, aby dowiedzieć się więcej o tym, co może zaoferować Pletly.",
			"information-library": "Biblioteka informacji",
			"you-can-easily-structure-necessary-information": "Możesz łatwo uporządkować niezbędne informacje o Wychowanku. \nMogą to być filmy z językiem migowym lub ćwiczeniami fizycznymi.",
			"welcome-to-pletly": "Witamy w Pletly!",
			"content": "Dziękujemy za dołączenie do Pletly! \nCieszymy się, że możemy powitać Cię na naszej platformie, na której staramy się poprawiać jakość opieki i poprawiać jakość życia poprzez wspieranie bliższych kontaktów w kręgu opieki i promowanie opieki skoncentrowanej na osobie.",
			"social-feed-content": "Zdobądź znaczący wgląd w codzienne życie podopiecznego za pośrednictwem naszego kanału społecznościowego, zachowując jednocześnie jego prywatność.",
			"social-feed-title": "Prywatny i bezpieczny kanał społecznościowy"
		},
		"block-user": "Zablokuj użytkownika",
		"report-post": "Zgłoś post",
		"report-sent": "Raport wysłany",
		"we-will-review-your-report-shortly": "Wkrótce sprawdzimy Twoje zgłoszenie",
		"user-blocked": "Użytkownik zablokowany",
		"are-you-sure-to-block-author-user": "Czy na pewno chcesz zablokować użytkownika {{user}}?",
		"are-you-sure-to-report-this-post": "Czy na pewno chcesz zgłosić ten wpis?",
		"this-will-hide-it-for-you-and-report-the-post-to-the-moderators": "To ukryje i zgłosi wpis moderatorom.",
		"you-will-not-see-content-from-this-user-anymore": "Nie będziesz już widzieć treści tego użytkownika.",
		"adding-media": "Dodawanie multimediów({{ count }})...",
		"book-post": {
			"new-book": "Nowa książka"
		},
		"add-media": "Dodaj media",
		"post-deleted": "Post został usunięty",
		"review": {
			"approve": "Zatwierdź",
			"reject": "Odrzuć",
			"confirm-reject-modal": {
				"title": "Czy na pewno chcesz odrzucić post {{authorName}}?",
				"content": "Proszę podać powód odrzucenia postu.",
				"reason-field-label": "Powód",
				"reason-field-placeholder": "Wpisz tutaj powód odrzucenia"
			},
			"posts-to-review-screen": {
				"subtitle": "Posty oczekujące na zatwierdzenie",
				"title": "Zatwierdzenie postów"
			},
			"status": {
				"pending": "Oczekujący",
				"rejected": "Odrzucony",
				"approved": "Zatwierdzony"
			},
			"review-submitted-successfully": "Recenzja przesłana pomyślnie",
			"posts-submitted-screen": {
				"subtitle": "Posty oczekujące na zatwierdzenie.",
				"title": "Zatwierdzenie postów",
				"reason": "Powód"
			},
			"discard": "Wyrzuć",
			"edit": "Edytuj",
			"menu": {
				"posts-under-review": "Posty w trakcie sprawdzania",
				"posts-to-review": "Posty do sprawdzenia"
			}
		},
		"share": {
			"share": "Udostępnij",
			"share-post": "Udostępnij post",
			"shared-post": "Udostępniony post",
			"shared-with": "Udostępniono użytkownikowi {{ name }}",
			"post-has-been-sent-in-a-chat-message": "Post został wysłany w wiadomości na czacie",
			"someone-shared-post": "{{authorName }} udostępnił Ci coś ważnego. \nKliknij tutaj, aby to sprawdzić."
		},
		"adding-media_zero": "Dodawanie multimediów...",
		"admin": "Administrator",
		"errors": {
			"forbidden": {
				"title": "Odmowa dostępu: Nieautoryzowany dostęp",
				"message": "\nWygląda na to, że nie masz uprawnień do przeglądania tej treści, ponieważ nie jesteś połączony z odpowiednim podopiecznym. \nTo ograniczenie ma na celu ochronę prywatności poufnych informacji.\n \nJeśli uważasz, że to pomyłka, sprawdź swoje połączenia lub skontaktuj się z osobą, która udostępniła post, aby uzyskać dalszą pomoc."
			}
		},
		"blur-faces": "Rozmycie twarzy",
		"accept": "Zaakceptować",
		"add-file": "Dodaj plik",
		"delete-file": "Usuń plik",
		"are-you-sure-you-want-to-delete": "Czy na pewno chcesz usunąć {{ name }}?",
		"file-deleted": "Usunięto plik",
		"file-has-been-deleted-successfully": "{{ name }} został pomyślnie usunięty.",
		"filters": {
			"modal": {
				"title": "Filtry",
				"published-in": {
					"custom-label": "Okres niestandardowy",
					"custom-placeholder": "Wybierz okres niestandardowy",
					"label": "Data publikacji",
					"option-days_one": "Ostatni dzień",
					"option-days_few": "Ostatnie {{count}} dni",
					"option-days_many": "Ostatnie {{count}} dni",
					"option-all-time": "Od zawsze"
				},
				"care-recipients": {
					"label": "Odbiorcy opieki",
					"no-care-recipients-to-select": "Brak odbiorców opieki do wyboru",
					"everyone": "Wszyscy",
					"selected-only": "Tylko wybrani"
				},
				"tags": {
					"label": "Tagi",
					"no-tags-selected": "Nie wybrano znaczników",
					"available-tags": "Dostępne tagi",
					"no-tags-available": "Brak dostępnych tagów"
				}
			},
			"btn-show": "Pokaż filtry",
			"btn-reset": "Zresetuj filtry"
		},
		"scheduled-posts": "Zaplanowane posty",
		"no-posts-scheduled": "Brak zaplanowanych postów",
		"publication-error-warning": "Nie udało się opublikować tego wpisu. \nPrzejrzyj swój post i spróbuj ponownie."
	},
	"profile": {
		"about-me": "O mnie",
		"are-you-sure-you-want-to-delete-profile-username-account-forever": "Czy na pewno chcesz na zawsze usunąć konto {{username}}?",
		"delete-profile-username-account": "Usuń konto {{username}}",
		"edit-information": "Edytuj informacje",
		"edit-profile": "Edytuj profil",
		"new-password": "Nowe hasło",
		"old-password": "Stare hasło",
		"change-password": "Zmień hasło",
		"password-changed": "Hasło zostało zmienione",
		"delete-account": "Usuń konto",
		"my-profile": "Mój profil",
		"saving-new-password": "Zapisywanie nowego hasła...",
		"saving-profile-photo": "Zapisuję zdjęcie profilowe...",
		"saving-user-information": "Zapisywanie informacji o użytkowniku...",
		"show-activity": "Pokaż aktywność",
		"critical": "Krytyczne",
		"negative": "Negatywne",
		"positive": "Pozytywne",
		"add-information": "Dodaj informacje",
		"send-message": "Wyślij wiadomość",
		"connections": "Kontakty",
		"feed": "Treści",
		"about": "O mnie",
		"new-information-folder": "Nowy folder informacyjny",
		"folder-name": "Nazwa folderu",
		"create-a-folder": "Utwórz folder",
		"edit-information-folder": "Edytuj folder informacyjny",
		"are-you-sure-remove-folder-name": "Czy na pewno chcesz usunąć folder informacyjny {{name}}?",
		"remove-folder": "Usuń folder",
		"add-folder-icon": "Dodaj ikonę folderu",
		"edit-folder-icon": "Edytuj ikonę folderu",
		"select-icon": "Wybierz ikonę",
		"save-information": "Zapisz informacje",
		"edit-folder": "Edytuj folder",
		"add-information-icon": "Dodaj ikonę informacji",
		"new-information": "Nowa informacja",
		"information-name": "Nazwa informacji",
		"edit-information-icon": "Edytuj ikonę informacji",
		"are-you-sure-remove-information-name": "Czy na pewno chcesz usunąć informację {{name}}?",
		"remove-information": "Usuń informację",
		"there-is-no-information-yet": "Nie ma jeszcze informacji.",
		"add-post-to-information": "Dodaj post do informacji",
		"there-are-no-posts-in-information": "Brak postów w informacjach.",
		"create-information": "Utwórz informację",
		"create-subfolder": "Utwórz podfolder",
		"delete-caregiver-confirm-title": "Rozłącz {{careGiverName}}",
		"delete-caregiver-confirm-content": "Czy na pewno chcesz usunąć połączenie {{careGiverName}} z {{careReceiverName}}?",
		"information-not-completed": "Ten Wychowanek nie ma uzupełnionych informacji",
		"fill-information": "Wypełnij informacje",
		"error-firstname-lastname-empty": "Imię i nazwisko nie mogą być puste",
		"error-username-empty": "Nazwa użytkownika nie może być pusta",
		"information": "Informacje",
		"repeat-new-password": "Powtórz nowe hasło",
		"this-action-cannot-be-undone": "Tej czynności nie można cofnąć",
		"improve-your-security-with-a-strong-password": "Zwiększ swoje bezpieczeństwo dzięki silnemu hasłu.",
		"passwords-do-not-match": "Hasła nie pasują do siebie",
		"restricted-access": "Ograniczony dostęp",
		"restricted-access-description": "Po wyłączeniu użytkownik będzie mógł dodawać posty i komentarze, polubić, edytować i usuwać istniejące.",
		"not-authorized-to-view-profile": "Nie masz uprawnień do przeglądania tego profilu.",
		"would-you-like-to-invite-as-caregiver-for": "Czy chcesz zaprosić {{careGiverName}} do zostania opiekunem dla {{careReceiverName}}?",
		"invite": "Zaproś",
		"invitation-sent": "Zaproszenie zostało wysłane",
		"revoke": "Unieważnij",
		"revoke-invitation-confirm-title": "Cofnąć zaproszenie?",
		"invitation-revoked": "Zaproszenie zostało wycofane",
		"profile-saved": "Profil został zapisany",
		"invite-to-become-caregiver": "Zaproś do zostania Opiekunem",
		"new-password-must-be-different-from-the-old-one": "Nowe hasło musi różnić się od starego",
		"invalid-password": "Nieprawidłowe hasło",
		"folder-access": {
			"access": "Dostęp",
			"access-to-the": "Dostęp do",
			"options": {
				"description-everyone": "Każdy podłączony Opiekun będzie miał dostęp do",
				"description-everyone-in-organisation": "Wszyscy opiekunowie z organizacji {{organisationName }} będą mieli dostęp do",
				"description-individual-caregivers": "Tylko wybrani Opiekunowie będą mieli dostęp do",
				"everyone": "Wszyscy",
				"everyone-in-organisation": "Wszyscy w organizacji",
				"individual-caregivers": "Opiekunowie indywidualni"
			},
			"set-access": "Ustaw dostęp",
			"caregiver-list": "Lista opiekunów",
			"no-caregivers-to-select": "Brak opiekunów do wyboru",
			"access-settings-saved": "Ustawienia dostępu zostały zapisane",
			"target-folder": "folderu",
			"target-information": "informacji"
		},
		"invite-caregivers": "Zaproś opiekunów",
		"no-user-posts": "Brak postów użytkowników",
		"create-first-post-on-user-feed-to-get-started": "Aby rozpocząć, utwórz pierwszy post w kanale użytkownika",
		"add-new-post": "Dodaj nowy wpis",
		"access-to-profile-expires": "Dostęp do tego profilu wygasa",
		"no-care-recipients-available": "Brak odbiorców opieki do wyboru",
		"files": "Pliki",
		"files-table": {
			"name": "Nazwa",
			"creator": "Twórca",
			"created-at": "Utworzony w",
			"connected-care-recipients": "Połączeni wychowankowie"
		}
	},
	"validations": {
		"error": "Błąd"
	},
	"onboarding": {
		"complete-your-account-setup": "Dokończ konfigurację konta",
		"what-is-your-name": "Jak masz na imię?",
		"first-name": "Imię",
		"last-name": "Nazwisko",
		"pletly-pal-is-the-platform-connecting-caregivers-and-facilitate-communication-with-care-receivers": "Pletly Pal to platforma łącząca Opiekunów i ułatwiająca komunikację z Wychowankami",
		"welcome-to-pletly-pal": "Witamy\n w Pletly Pal",
		"welcome-to-pletly-care": "Witaj\n w Pletly Care",
		"add-phone-number": "Dodaj numer telefonu",
		"by-adding-your-phone-number-you-are-providing-other-caregivers-an-option-to-contact-you-outside-the-pletly-ecosystem": "Dodając swój numer telefonu, zapewniasz innym Opiekunom możliwość skontaktowania się z Tobą poza ekosystemem Pletly",
		"add-connections": "Dodaj połączenia",
		"connect-with-existing-user": "Połącz z istniejącym użytkownikiem",
		"create-account-for-care-receiver": "Utwórz konto dla Wychowanka",
		"create-new-account-for-a-care-receiver-or-connect-to-one-if-account-is-already-created": "Utwórz nowe konto dla Wychowanka lub połącz się z nim, jeśli konto zostało już utworzone",
		"bio-card-description": "Przekaż innym Opiekunom w ekosystemie Pletly kim jesteś i jaka jest Twoja rola.",
		"bio-card-title": "Wypełnij swoją biografię",
		"connect-card-description": "Aby móc używać Pletly Pal zgodnie z przeznaczeniem, musisz być podłączony do jednego lub więcej Wychowanków.",
		"connect-card-title": "Podłącz do Wychowanka",
		"name-card-description": "Podaj swoje imię i nazwisko. \nTwoja tożsamość jest ważna w zapewnianiu wysokiej jakości komunikacji.",
		"name-card-title": "Dodaj swoje imię",
		"phone-card-description": "Podanie nam swojego numeru telefonu w razie potrzeby stworzy dodatkową linię komunikacji.",
		"phone-card-title": "Dodaj numer telefonu",
		"photo-card-description": "Dodaj zdjęcie, bo jesteś piękny!",
		"photo-card-title": "Dodaj zdjęcie profilowe",
		"post-card-description": "Opublikuj informacje lub multimedia, którymi chcesz się podzielić z innymi Opiekunami w sieci Wychowanka.",
		"post-card-title": "Opublikuj coś",
		"add-another-post": "Dodaj kolejny post",
		"add-bio": "Dodaj biografię",
		"add-name": "Dodaj nazwę",
		"add-phone": "Dodaj telefon",
		"add-photo": "Dodaj zdjęcie",
		"add-post": "Dodaj post",
		"connect": "Połącz",
		"connect-more": "Połącz więcej",
		"edit-bio": "Edytuj biografię",
		"edit-name": "Zmień imię",
		"edit-phone": "Edytuj telefon",
		"edit-photo": "Edytuj zdjęcie",
		"complete-your-profile": "Uzupełnij swój profil",
		"congratulations": "Gratulacje!",
		"your-profile-is-complete": "Twój profil jest kompletny!",
		"profile-completed": "Profil kompletny"
	},
	"lock": {
		"hello": "cześć",
		"or-just-use-password-instead": "lub po prostu użyj hasła zamiast tego",
		"use-fingerprint-to-login-to-your-account": "Dbamy o prywatność naszych podopiecznych. Potwierdź uwierzytelnienie, aby uzyskać dostęp do Pletly Pal.",
		"cant-unlock": "Nie możesz odblokować?"
	},
	"conversations": {
		"conversation-details": "Szczegóły rozmowy",
		"group-name": "Nazwa grupy",
		"group-participants": "Uczestnicy",
		"edit-chat": "Edytuj czat",
		"add-chat": "Dodaj czat",
		"chats": "Czaty",
		"sending-private-message": "Wysyłanie prywatnej wiadomości...",
		"my-chats": "Moje czaty",
		"create-new-chat": "Utwórz nowy czat",
		"create-group-chat": "Utwórz czat grupowy",
		"create": "Utwórz",
		"screen-title": "Wiadomości",
		"type-message-here": "Wpisz wiadomość tutaj...",
		"messages-seen-by-name-on-when": "Wiadomości widziane przez {{ name }} w dniu {{ when }}",
		"report-message": "Zgłoś wiadomość",
		"edit-info": "Aby edytować ten czat grupowy (dodaj lub usuń uczestników itp.), Naciśnij ikonę ołówka w prawym górnym rogu.",
		"access-messages": "Uzyskaj dostęp do wiadomości",
		"all-participants-in-the-chat-will-be-notified": "Wszyscy uczestnicy czatu zostaną powiadomieni.",
		"to-access-the-content-of-this-chat-click-the-button-below-all-participants-in-the-chat-will-be-notified": "Aby uzyskać dostęp do zawartości tego czatu, kliknij przycisk poniżej. \nWszyscy uczestnicy czatu zostaną powiadomieni.",
		"are-you-sure-to-report-this-message": "Czy na pewno chcesz zgłosić tę wiadomość?",
		"you-will-not-see-this-message-anymore-and-we-will-review-your-report-shortly": "Nie zobaczysz już tej wiadomości i wkrótce przejrzymy Twój raport.",
		"are-you-sure-you-want-to-delete-this-conversation": "Czy na pewno chcesz usunąć tę rozmowę?",
		"failed-to-delete-conversation": "Nie udało się usunąć rozmowy",
		"no-results": "Brak wyników"
	},
	"menu": {
		"title": "Menu",
		"edit-profile": "Edytuj profil",
		"about-app": "O aplikacji",
		"settings-link": "Ustawienia",
		"log-out": "Wyloguj",
		"settings": {
			"title": "Ustawienia",
			"notifications": {
				"title": "Powiadomienia",
				"all-notifications": "Wszystkie powiadomienia",
				"new-post": "Nowy post",
				"direct-message": "Prywatne wiadomości",
				"new-like-on-post": "Nowe polubienie pod postem",
				"new-comment-on-post": "Nowy komentarz do posta"
			},
			"security": {
				"title": "Bezpieczeństwo",
				"master-lock": "Zabezpieczenie biometryczne",
				"lock-description": "Aplikacja Pletly Pal blokuje się automatycznie po {{minutes}} minutach bezczynności i można ją odblokować za pomocą TouchID, FaceID lub kodu dostępu."
			}
		},
		"switch-to-organisation-panel": "Przejdź do panelu organizacji",
		"my-files": "Moje pliki"
	},
	"verification": {
		"an-email-has-been-sent-to": "E-mail został wysłany do",
		"please-click-on-link-to-verify-your-email-address": "Kliknij link, aby zweryfikować swój adres e-mail",
		"resend-email": "Wyślij ponownie",
		"sent-please-check-your-email": "Wysłano email, sprawdź pocztę",
		"verify-email": "Zweryfikuj adres e-mail",
		"your-email-has-been-successfully-verified": "Twój e-mail został pomyślnie zweryfikowany."
	},
	"paywall": {
		"activate-premium": "Aktywuj premium",
		"create-up-to-n-care-receivers-and-enjoy-unlimited-number-of-connections": "Utwórz do {{count}} Wychowanków i ciesz się nieograniczoną liczbą połączeń",
		"maybe-later": "Może później",
		"subscribe": "Subskrybuj",
		"you-can-cancel-your-subscription-at-anytime": "Możesz anulować subskrypcję w dowolnym momencie",
		"try-premium": "Wypróbuj premium",
		"get-premium": "Zdobądź premium",
		"get-premium-and-enjoy-an-unlimited-number-of-connections": "Zdobądź premium i ciesz się nieograniczoną liczbą połączeń",
		"get-started": "Rozpocznij",
		"for-the-first": "Przez pierwsze",
		"then": "następnie",
		"periods": {
			"day_one": "dzień",
			"day_few": "{{count}} dni",
			"day_many": "{{count}} dni",
			"month_one": "miesiąc",
			"month_few": "{{count}} miesiące",
			"month_many": "{{count}} miesięcy",
			"year_one": "rok",
			"year_few": "{{count}} lata",
			"year_many": "{{count}} lat"
		}
	},
	"add-image": {
		"select-photo-from-gallery": "Wybierz zdjęcie z galerii",
		"take-photo": "Zrób zdjęcie",
		"record-video": "Nagraj wideo",
		"permission-to-access-camera-roll-is-required": "Wymagane jest zezwolenie na dostęp do rolki aparatu!"
	},
	"header": {
		"home": "Strona domowa",
		"connections": "Kontakty",
		"notifications": "Powiadomienia",
		"messages": "Wiadomości",
		"search-for-connections": "Szukaj połączeń",
		"communities": "Społeczności",
		"ai": "AI"
	},
	"notifications": {
		"there-are-no-notifications": "Brak powiadomień.",
		"no-new-updates-right-now-youll-be-the-first-to-know-when-theres-something-new": "W tej chwili nie ma żadnych nowych aktualizacji. \nBędziesz pierwszą osobą, która dowie się, gdy pojawi się coś nowego."
	},
	"community": {
		"create-new-community": "Utwórz nową społeczność",
		"community-name": "Nazwa społeczności",
		"add-name-here": "Dodaj nazwę tutaj...",
		"community-description": "Opis społeczności",
		"add-description-here": "Dodaj opis tutaj...",
		"privacy-settings": "Ustawienia prywatności",
		"pick-privacy-setting": "Wybierz ustawienie prywatności",
		"admins": "Administratorzy",
		"communities": "Społeczności",
		"community-members": "Członkowie społeczności",
		"create-new-post": "Utwórz nowy post",
		"explore": "Odkrywaj",
		"find-users-to-add": "Znajdź użytkowników do dodania",
		"invite": "Zaproś",
		"invite-to-community": "Zaproś do społeczności",
		"invite-users": "Zaproś użytkowników",
		"join": "Dołącz",
		"leave": "Opuść",
		"make": "Robić",
		"manage-members": "Zarządzaj członkami",
		"members": "członkowie",
		"private": "Prywatny",
		"public": "Publiczny",
		"your-communities": "Twoje społeczności",
		"add-post-to-the-community": "Dodaj post do społeczności...",
		"join-owner": "Właściciel",
		"joined": "Dołączono",
		"are-you-sure-you-want-to-make-this-group-privacy": "Czy na pewno chcesz ustawić tę grupę jako {{privacy}}?",
		"change-group-visibility": "Zmień widoczność grupy",
		"community-you-belong-to": "Społeczność, do której należysz",
		"invitations": "Zaproszenia",
		"community-you-manage": "Społeczność, którą zarządzasz",
		"group-visibility-updated": "Zaktualizowano widoczność grupy",
		"join-request-sent": "Wysłano prośbę o dołączenie",
		"your-request-has-been-sent-to-the-community-owner": "Twoja prośba została wysłana do właściciela społeczności",
		"leave-community": "Opuść społeczność",
		"delete-community": "Usuń społeczność",
		"are-you-sure-you-want-to-delete": "Czy na pewno chcesz usunąć {{ name }}?",
		"invites-sent": "Zaproszenia wysłane",
		"invited": "Zaproszono",
		"admin-removed": "Administrator usunięty",
		"are-you-sure-you-want-to-leave-this-community": "Czy na pewno chcesz opuścić tę społeczność?",
		"invite-removed": "Zaproszenie usunięte",
		"admin-added": "Dodano administratora",
		"are-you-sure-you-want-to-remove-member": "Czy na pewno chcesz usunąć {{name}}?",
		"member-removed": "Członek został usunięty",
		"remove-member": "Usuń członka"
	},
	"summarization": {
		"from-date-until-date": "od {{fromDate}} do {{toDate}}",
		"generate-summary": "Generuj podsumowanie postów",
		"generating-summary": "Generuję podsumowanie...",
		"no-posts-to-summarize": "Brak postów podsumowujących ten okres",
		"posts-summary": "Podsumowanie postów",
		"select-dates": "Wybierz daty",
		"select-from-date": "Wybierz od daty",
		"select-to-date": "Wybierz do tej pory",
		"summarize-posts": "Podsumuj posty",
		"warning-text": "Treść wygenerowana przez AI może zawierać błędy. Użyj swojego rozsądku i sprawdź ważne fakty.",
		"key-insights": "Punkty kluczowe",
		"suggestions": "Sugestie",
		"mood": "Nastrój"
	},
	"zod": {
		"only-letters-numbers-and-underscores-are-allowed": "Dozwolone są tylko litery, cyfry i podkreślenia"
	},
	"no-information-folders": "Brak folderów informacyjnych",
	"create-your-first-folder-to-get-started": "Aby rozpocząć, utwórz swój pierwszy folder",
	"undo": "Cofnij",
	"edit-profile-form": {
		"receive-summary-notification-emails": "Otrzymuj e -maile podsumowujące"
	},
	"upload-new-file": "Prześlij nowy plik"
}
